















































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
// import Graph from '@/app/components/FieldDetails/Graph/Graph.vue'
import StageUpdateModal from '@/app/components/FieldDetails/Graph/StageUpdateModal.vue'
import GraphDialog from '@/app/components/FieldDetails/Graph/GraphDialog.vue'
/* module */
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import CommonClass from '@/app/module/common'
import { harvestStatus } from '@/app/model/store/domain/const'
/* pulugin */
import * as ChartAnnotation from 'chartjs-plugin-annotation'
import * as ChartDraggable from 'chartjs-plugin-draggable'
import SetFlagState from '../../../model/store/domain/SetFlagState'

@Component({
  components: {
    Graph: () => import('@/app/components/FieldDetails/Graph/Graph.vue'),
    StageUpdateModal,
    GraphDialog
  }
})
export default class FieldGraph extends Vue {
  private label: any[] = []
  private value: any = new Date()
  private showStageUpdateModal: boolean = false
  private showDetailsDialog: boolean = false
  private showAreaChart: boolean = false
  private showYoungHeadChart: boolean = true
  private stageDate: string = ''
  private growthData: {[key: string]: string|number|any} = {}
  private dialogTop: string = '0px'
  private dialogLeft: string = '0px'
  private testHarvestTimeColor: string = 'rgba(200,200,200,.5)'
  private goalHarvestTimeColor: string = 'rgba(252,219,192,.5)'
  private harvestTimeColor: string = 'rgba(255,192,0,.4)'
  private transparentColor: string = 'rgba(0, 0, 0, 0)'
  private graphMaxDay: any = ''
  private slideWidth: number = 0
  private slideTop: number = 35
  private slide: number = 0
  public chartData: any = {}
  public areaChartData: any = {}
  public youngHeadChartData: any = {}
  private agrinoteRecodsData: any[] = []
  private agrinoteData: any[] = []
  private checkboxData: any = []
  private cameraIcon: any = require('@/assets/img/camera.png')
  public chartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      var text = []
      text.push('<ul class="' + chart.id + '-legend">')
      let legendSort = ['実績積算温度(℃)', '比較積算温度(℃)', '目標積算温度(℃)', '予測積算温度(℃)', '検証積算温度(℃)', '実績茎数(本)', '比較茎数(本)', '目標茎数(本)', '実績SPAD', '比較SPAD', '目標SPAD', '実績草丈(cm)', '比較草丈(cm)', '目標草丈(cm)']
      const items = JSON.parse(JSON.stringify(chart.legend.legendItems))

      items.sort(function (x: any, y: any) {
        return legendSort.indexOf(x.text) - legendSort.indexOf(y.text)
      })
      for (var i = 0; i < items.length; i++) {
        // 凡例のテキストがない場合
        if (items[i].text === undefined) {
          text.push('<li><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
          if (items[i]) {
            text.push(items[i].text)
          }
          text.push('</span></li>')
        } else {
          // 比較データの場合は色を薄くする
          if (items[i].text.startsWith('比較')) {
            text.push('<li class="disabled"><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
            if (items[i]) {
              text.push(items[i].text)
            }
            text.push('</span></li>')
          } else {
            // 比較以外
            // 検証グラフデータが無ければ凡例・グラフを非表示
            if (items[i].text === '検証積算温度(℃)') {
              if (Session.getTestData() === null) {
                text.push('<li class="hidden" style="display: none;"><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
              } else {
                text.push('<li class="hidden"><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
                if (items[i]) {
                  text.push(items[i].text)
                }
              }
              text.push('</span></li>')
            // hiddenのclassを付与するかどうか
            } else if (items[i].text === '実績茎数(本)' ||
                items[i].text === '比較茎数(本)' ||
                items[i].text === '目標茎数(本)' ||
                items[i].text === '実績SPAD' ||
                items[i].text === '比較SPAD' ||
                items[i].text === '目標SPAD') {
              text.push('<li class="hidden"><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
              if (items[i]) {
                text.push(items[i].text)
              }
              text.push('</span></li>')
            } else {
              text.push('<li><span class="legend-color" style="background-color:' + items[i].strokeStyle + '"></span><span>')
              if (items[i]) {
                text.push(items[i].text)
              }
              text.push('</span></li>')
            }
          }
        }

        if (i === 4 || i === 7 || i === 10) {
          text.push('</br>')
        }
      }

      text.push('</ul>')

      return 0 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 20,
        bottom: 20,
        right: 20
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '積算温度(℃)'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            min: 0,
            max: 1200,
            stepSize: 300
          },
          position: 'right'
        },
        {
          id: 'yAxis_2',
          type: 'linear',
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true,
            labelString: '茎数・草丈・SPAD'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            min: 0,
            max: 100,
            stepSize: 20
          },
          position: 'left'
        }
      ]
    },
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date: any
          let displayDate: any

          // 比較草丈の場合
          if (tooltipItem[0].datasetIndex === 12) {
            /* 播種日同士の差分を求める */
            let plantingDay = DateClass.formingDate(Session.getPlantingDay()!)
            let comparisonPlant = DateClass.formingDate(Object.keys(JSON.parse(Session.getComparisonData()!))[0])
            let diff = plantingDay.getTime() - comparisonPlant.getTime()
            diff = Math.floor(diff / (1000 * 60 * 60 * 24))

            date = new Date(tooltipItem[0].xLabel)
            date.setDate(date.getDate() - diff)
            displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          } else {
            date = new Date(tooltipItem[0].xLabel)
            displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          }

          let today = new Date().getFullYear() + '年' + (new Date().getMonth() + 1) + '月' + (new Date().getDate() - 1) + '日'
          if (displayDate === today) {
            displayDate += '(最新データ)'
          }

          return displayDate
        }
      }
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    annotation: {
      events: ['click', 'drag', 'mouseover'],
      annotations: []
    }
  }
  public areaChartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      var text = []
      text.push('<ul class="' + chart.id + '-legend">')
      for (var i = 0; i < chart.legend.legendItems.length; i++) {
        // 凡例のテキストがない場合
        if (chart.legend.legendItems[i].text === undefined) {
          text.push('<li><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
          if (chart.legend.legendItems[i]) {
            text.push(chart.legend.legendItems[i].text)
          }
          text.push('</span></li>')
        } else {
          // 比較データの場合は色を薄くする
          if (chart.legend.legendItems[i].text.startsWith('比較')) {
            text.push('<li class="disabled"><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
            if (chart.legend.legendItems[i]) {
              text.push(chart.legend.legendItems[i].text)
            }
            text.push('</span></li>')
          } else {
            // 比較以外
            // hiddenのclassを付与するかどうか
            if (chart.legend.legendItems[i].hidden) {
              text.push('<li class="hidden"><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
              if (chart.legend.legendItems[i]) {
                text.push(chart.legend.legendItems[i].text)
              }
              text.push('</span></li>')
            } else {
              text.push('<li><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
              if (chart.legend.legendItems[i]) {
                text.push(chart.legend.legendItems[i].text)
              }
              text.push('</span></li>')
            }
          }
        }

        if (i === 3 || i === 6 || i === 9) {
          text.push('<br/>')
        }
      }
      text.push('</ul>')

      return 1 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 20,
        bottom: 20,
        right: 80
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '積算降水量(mm)'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            min: 0,
            maxTicksLimit: 4
          },
          position: 'left'
        }
      ]
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date = new Date(tooltipItem[0].xLabel)
          let displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          return displayDate
        }
      }
    }
  }

  public youngHeadChartOptions: any = {
    responsive: true,
    animation: false,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      var text = []
      text.push('<ul class="' + chart.id + '-legend">')
      for (var i = 0; i < chart.legend.legendItems.length; i++) {
        // 凡例のテキストがない場合
        if (chart.legend.legendItems[i].text === undefined) {
          text.push('<li><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
          if (chart.legend.legendItems[i]) {
            text.push(chart.legend.legendItems[i].text)
          }
          text.push('</span></li>')
        } else {
          // 比較データの場合は色を薄くする
          if (chart.legend.legendItems[i].text.startsWith('比較')) {
            text.push('<li class="disabled"><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
            if (chart.legend.legendItems[i]) {
              text.push(chart.legend.legendItems[i].text)
            }
            text.push('</span></li>')
          } else {
            // 比較以外
            // hiddenのclassを付与するかどうか
            if (chart.legend.legendItems[i].hidden) {
              text.push('<li class="hidden"><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
              if (chart.legend.legendItems[i]) {
                text.push(chart.legend.legendItems[i].text)
              }
              text.push('</span></li>')
            } else {
              text.push('<li><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
              if (chart.legend.legendItems[i]) {
                text.push(chart.legend.legendItems[i].text)
              }
              text.push('</span></li>')
            }
          }
        }

        if (i === 3 || i === 6 || i === 9) {
          text.push('</br>')
        }
      }
      text.push('</ul>')

      return 2 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 20,
        bottom: 20,
        right: 80
      }
    },
    scales: {
      xAxes: [
        {
          id: 'x-axis-0',
          offset: false,
          gridLines: {
            display: true
          },
          type: 'time',
          time: {
            unit: 'month',
            displayFormats: {
              month: 'M' + '月'
            }
          },
          ticks: {
            display: true,
            autoSkip: true,
            fontSize: 14
          },
          scaleLabel: {
            labelString: '月'
          }
        }
      ],
      yAxes: [
        {
          id: 'yAxis_1',
          type: 'linear',
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            labelString: '幼穂長(cm)'
          },
          ticks: {
            autoSkip: true,
            fontSize: 14,
            maxTicksLimit: 4,
            min: 0,
            max: 10
          },
          position: 'left'
        }
      ]
    },
    plugins: [
      ChartAnnotation,
      ChartDraggable
    ],
    tooltips: {
      backgroundColor: 'rgb(98,118,106)',
      titleFontSize: 14,
      xPadding: 10,
      yPaddin: 10,
      callbacks: {
        title (tooltipItem: any, data: any) {
          let date = new Date(tooltipItem[0].xLabel)
          let displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
          return displayDate
        }
      }
    }
  }

  // アグリノート画像の日付title表示用
  private displayDate (date: number) {
    let year = String(date).slice(0, 4)
    let month = String(date).slice(4, 6)
    let day = String(date).slice(6)

    return year + '年' + month + '月' + day + '日' + ' 撮影画像'
  }

  private get getGlobalData (): any {
    return this.$store.state.setFlagState.growthDialogFlag
  }
  @Watch('getGlobalData')
  updateDialog (flag: boolean) {
    if (flag) {
      this.showGraphDialog()
      // flagリセット
      this.$store.commit('setFlagState/setGrowthDialogFlag', false)
    }
  }

  private get growthList (): any {
    return this.$store.state.stageUpdateState.defaultStageData
  }
  private get toggleComparison (): any {
    return this.$store.state.graphToggleState.hiddenComparisonData
  }
  @Watch('growthList')
  updateList (newValue: any) {
    this.updateStageBar(newValue)
  }
  @Watch('toggleComparison')
  hiddenToggleGraph (flag: boolean) {
    if (flag) {
      this.changeComparisonGraph()
    }
  }

  private get comparisonPlant (): any {
    return this.$store.state.setFlagState.comparisonPlantFlag
  }
  private get comparisonMaster (): any {
    return this.$store.state.setFlagState.comparisonMasterFlag
  }
  @Watch('comparisonPlant')
  updateComparison (flag: boolean) {
    if (flag && this.$store.state.setFlagState.comparisonMasterFlag) {
      this.createComparisonData()
      this.$store.commit('setFlagState/setComparisonPlantFlag', false)
      this.$store.commit('setFlagState/setComparisonMasterFlag', false)
    }
  }
  @Watch('comparisonMaster')
  updateComparison2 (flag: boolean) {
    if (flag && this.$store.state.setFlagState.comparisonPlantFlag) {
      this.createComparisonData()
      this.$store.commit('setFlagState/setComparisonMasterFlag', false)
      this.$store.commit('setFlagState/setComparisonPlantFlag', false)
    }
  }

  // スライドバーの更新
  private get fieldDeatilsState (): number {
    return this.$store.state.dateChoiceState.changeDate
  }
  @Watch('fieldDeatilsState')
  onChangeKeydate (newVal: string) {
    let fiestDay: any = '' + this.label[0].getFullYear() + DateClass.toDoubleDigits(this.label[0].getMonth() + 1) + DateClass.toDoubleDigits(this.label[0].getDate())
    let date = DateClass.daysCalculation(parseInt(fiestDay), parseInt(newVal))

    // 矢印から変更した時のみグラフを再レンダリングする
    if (this.$store.state.dateChoiceState.arrowClick) {
      this.slide = date
      // flagリセット
      this.$store.commit('dateChoiceState/setArrowClick', false)
    }
  }

  private changeImageModal (date: any) {
    this.$store.commit('fieldDetailsState/setAgrinoteImgDate', date.record_date)
    this.$store.commit('setFlagState/setAgrinoteImgFlag', true)
  }

  created () {
    this.createChartData()
    this.createAreaChartData()
    this.createyoungHeadChartData()

    let growthStageList = JSON.parse(Session.getGrowthStage()!)
    this.createStageBar(growthStageList)

    // スライドバーの初期位置
    let graphData: any = JSON.parse(Session.getGraphData()!)
    let lastDay: any = Object.keys(graphData).pop()
    let fiestDay: any = '' + this.label[0].getFullYear() + DateClass.toDoubleDigits(this.label[0].getMonth() + 1) + DateClass.toDoubleDigits(this.label[0].getDate())
    let keyDate = DateClass.daysCalculation(fiestDay, lastDay)
    this.slide = keyDate

    var userAgent = window.navigator.userAgent.toLowerCase()
    // firefoxのみ開始位置が中心のためtopを変更
    if (userAgent.indexOf('firefox') !== -1) {
      this.slideTop = 264
    }

    // 検証収穫適期幅は初期非表示
    this.chartOptions.annotation.annotations[15].backgroundColor = 'rgba(0, 0, 0, 0)'
    this.chartOptions.annotation.annotations[15].borderColor = 'rgba(0, 0, 0, 0)'
  }

  mounted () {
    window.addEventListener('resize', this.resizeWidth)
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.resizeWidth)
  }

  public resizeWidth () {
    setTimeout(this.setResizeWidth, 200)
  }

  public setResizeWidth () {
    let canvas: any = document.getElementById('line-chart')
    let canvasWidth = canvas.style.width.replace(/px/g, '')
    this.slideWidth = parseInt(canvasWidth) - 150

    this.setCameraIcon()
  }

  private setCameraIcon () {
    this.agrinoteRecodsData = JSON.parse(Session.getAgrinoteRecods()!)
    setTimeout(this.changePosition, 200)
  }

  private changePosition () {
    this.agrinoteData = []
    let oneDayWidth = (this.slideWidth - 25) / (this.label.length - 1)
    for (var j in this.label) {
      for (let i in this.agrinoteRecodsData) {
        let year = this.label[j].getFullYear()
        let month = '0' + (this.label[j].getMonth() + 1)
        let date = '0' + this.label[j].getDate()
        let day = '' + this.label[j].getFullYear() + month.slice(-2) + date.slice(-2)

        if (day === String(this.agrinoteRecodsData[i].record_date)) {
          let position = parseInt(j) * oneDayWidth
          this.agrinoteData.push({
            left: position,
            record_date: this.agrinoteRecodsData[i].record_date
          })
        }
      }
    }
  }

  public updateDisplayYear () {
    /* データ取り直し */
    this.chartOptions.annotation.annotations[0].xMin = this.getMinHarvestTime()
    this.chartOptions.annotation.annotations[0].xMax = this.getMaxHarvestTime()

    this.createChartData()
    this.createAreaChartData()
    this.createyoungHeadChartData()
    this.displayGraph(this.checkboxData)

    // 再レンダリング
    let graph: any = this.$refs.graph
    let areaGraph: any = this.$refs.areaGraph
    let youngHeadGraph: any = this.$refs.youngHeadGraph

    if (graph !== undefined) {
      graph.updateGraph()
      areaGraph.updateGraph()
      youngHeadGraph.updateGraph()
      this.setCameraIcon()
    }
  }

  /* chartの基本データ */
  public createChartData () {
    this.chartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '実績積算温度(℃)',
          backgroundColor: '#0f6594',
          borderColor: '#0f6594',
          fill: false,
          hidden: false,
          spanGaps: true,
          pointRadius: this.judgePointRadius(this.createGraphData('integration_temperature', 'performance')),
          pointBorderColor: this.performancePointBgColor,
          pointBackgroundColor: this.performancePointBgColor,
          data: this.createGraphData('integration_temperature', 'performance'),
          order: 2
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較積算温度(℃)',
          backgroundColor: '#6a9eba',
          borderColor: '#6a9eba',
          fill: false,
          hidden: false,
          spanGaps: true,
          pointRadius: 0,
          data: [0],
          order: 3
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '目標積算温度(℃)',
          backgroundColor: '#aec7d6',
          borderColor: '#aec7d6',
          fill: false,
          hidden: false,
          spanGaps: true,
          data: this.createGraphData('integration_temperature', 'goal'),
          order: 4
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '予測積算温度(℃)',
          backgroundColor: '#0f6594',
          borderColor: '#0f6594',
          fill: false,
          hidden: false,
          spanGaps: true,
          borderDash: [5, 5],
          pointBorderColor: this.predictionPointBgColor,
          pointBackgroundColor: this.predictionPointBgColor,
          data: this.createPredictionTemperature(),
          order: 1
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '検証積算温度(℃)',
          backgroundColor: '#8064A2',
          borderColor: '#8064A2',
          fill: false,
          hidden: true,
          spanGaps: true,
          data: this.createGraphData('integration_temperature', 'test_graph'),
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績茎数(本)',
          backgroundColor: '#31e7ba',
          borderColor: '#31e7ba',
          hidden: true,
          fill: false,
          spanGaps: true,
          pointRadius: this.judgePointRadius(this.createGraphData('stem_number', 'performance')),
          data: this.createGraphData('stem_number', 'performance'),
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較茎数(本)',
          backgroundColor: '#7EECD1',
          borderColor: '#7EECD1',
          fill: false,
          hidden: false,
          spanGaps: true,
          pointRadius: 0,
          data: [0],
          order: 3
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '目標茎数(本)',
          backgroundColor: '#B8EFE1',
          borderColor: '#B8EFE1',
          fill: false,
          spanGaps: true,
          hidden: true,
          data: this.createGraphData('stem_number', 'goal'),
          order: 4
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績SPAD',
          backgroundColor: '#F94D83',
          borderColor: '#F94D83',
          fill: false,
          hidden: true,
          spanGaps: true,
          pointRadius: this.judgePointRadius(this.createGraphData('spad', 'performance')),
          data: this.createGraphData('spad', 'performance'),
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較SPAD',
          backgroundColor: '#F68FB0',
          borderColor: '#F68FB0',
          fill: false,
          hidden: false,
          spanGaps: true,
          pointRadius: 0,
          data: [0],
          order: 3
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '目標SPAD',
          backgroundColor: '#F4C0D1',
          borderColor: '#F4C0D1',
          fill: false,
          spanGaps: true,
          hidden: true,
          data: this.createGraphData('spad', 'goal'),
          order: 4
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '実績草丈(cm)',
          backgroundColor: '#0B8C41',
          borderColor: '#0B8C41',
          barThickness: 10,
          fill: false,
          spanGaps: true,
          hidden: false,
          pointRadius: this.judgePointRadius(this.createGraphData('growth_height', 'performance')),
          data: this.createGraphData('growth_height', 'performance'),
          order: 2
        },
        {
          yAxisID: 'yAxis_2',
          type: 'line',
          label: '比較草丈(cm)',
          backgroundColor: '#68B588',
          borderColor: '#68B588',
          barThickness: 10,
          hidden: true,
          spanGaps: true,
          fill: false,
          pointRadius: 0,
          data: [0],
          order: 3
        },
        {
          yAxisID: 'yAxis_2',
          type: 'bar',
          label: '目標草丈(cm)',
          backgroundColor: '#ACD3BD',
          borderColor: '#ACD3BD',
          barThickness: 10,
          fill: false,
          hidden: false,
          z: 1000,
          data: this.createGraphData('growth_height', 'goal'),
          order: 4
        }
      ]
    }
  }

  public createAreaChartData () {
    this.areaChartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          // id: 'Temprature',
          label: '実績積算降水量(mm/day)',
          backgroundColor: '#51B4E9',
          borderColor: '#51B4E9',
          fill: false,
          hidden: false,
          pointRadius: this.judgePointRadius(this.createGraphData('integrated_precipitation_amount', 'performance')),
          data: this.createGraphData('integrated_precipitation_amount', 'performance')
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較積算降水量(mm/day)',
          backgroundColor: '#92CDED',
          borderColor: '#92CDED',
          hidden: false,
          fill: false,
          pointRadius: 0,
          data: [0]
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          // id: 'Temprature',
          label: '予測積算降水量(mm/day)',
          backgroundColor: 'rgba(81, 180, 233, 0.3)',
          borderColor: 'rgba(81, 180, 233, 0.3)',
          hidden: false,
          fill: true,
          spanGaps: true,
          data: this.createGraphData('integrated_precipitation_amount', 'goal')
        }
      ]
    }
  }

  public createyoungHeadChartData () {
    this.youngHeadChartData = {
      events: ['click', 'hover'],
      labels: this.getLabels(),
      datasets: [
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          // id: 'Temprature',
          label: '実績幼穂長(㎝)',
          backgroundColor: '#92d04f',
          borderColor: '#92d04f',
          hidden: false,
          fill: false,
          spanGaps: true,
          data: this.createGraphData('young_head', 'performance')
        },
        {
          yAxisID: 'yAxis_1',
          type: 'line',
          label: '比較幼穂長(cm)',
          backgroundColor: '#d5e5ad',
          borderColor: '#d5e5ad',
          hidden: true,
          fill: false,
          spanGaps: true,
          data: []
        },
        {
          yAxisID: 'yAxis_1',
          type: 'bar',
          // id: 'Temprature',
          label: '目標幼穂長(cm)',
          backgroundColor: '#77933b',
          borderColor: '#77933b',
          fill: false,
          hidden: false,
          barThickness: 8,
          spanGaps: true,
          pointRadius: 0,
          data: this.createGraphData('young_head', 'goal')
        }
      ]
    }
  }

  /* 今日のポイントのみ色を変える(実測) */
  public performancePointBgColor () {
    const points = this.createGraphData('integration_temperature', 'performance')
    const graphData = JSON.parse(Session.getGraphData()!)
    const todayColor = '#ff0000'
    const defaultColor = '#0f6594'
    // すべてdefaultColorの配列を作る
    const bgColors = new Array(Object.keys(graphData).length)
    bgColors.fill(defaultColor)

    // 最終日のみ赤を入れる
    if (points.length !== 0) {
      // null以外で配列を作成
      const array = points.filter((val) => val !== null)
      // 最後の値が何か取得
      const lastDayVal = array.pop()
      // 実績積算温度配列の後ろからlastDayValの配列番号を取得
      const key = points.lastIndexOf(lastDayVal)
      bgColors[key] = todayColor
    }

    return bgColors
  }

  /* 今日のポイントのみ色を変える(予測) */
  public predictionPointBgColor () {
    const points = this.createPredictionTemperature()
    const plantingData = this.createGraphData('integration_temperature', 'performance')
    const graphData = JSON.parse(Session.getGraphData()!)
    const todayColor = '#ff0000'
    const defaultColor = '#0f6594'
    // すべてdefaultColorの配列を作る
    const bgColors = new Array(Object.keys(graphData).length)
    bgColors.fill(defaultColor)

    // 最終日のみ赤を入れる
    if (points.length !== 0) {
      // null以外で配列を作成
      const array = plantingData.filter((val) => val !== null)
      // 最後の値が何か取得
      const lastDayVal = array.pop()
      // 実績積算温度配列の後ろからlastDayValの配列番号を取得
      const key = plantingData.lastIndexOf(lastDayVal)
      bgColors[key] = todayColor
    }

    return bgColors
  }

  /* chartのラベルを作成 */
  public getLabels () {
    const labels: any[] = []
    let plantingDay = String(JSON.parse(Session.getPlantingDay()!))
    let graphData = JSON.parse(Session.getGraphData()!)
    let graphDataLastDay = String(Object.keys(graphData).pop())
    let graphLastDay = String(Session.getEstimatedDate()!)
    // 始まりを播種日-10日にする
    let minDay = DateClass.formingDate(plantingDay)
    minDay.setDate(minDay.getDate() - 10)

    let masterData = JSON.parse(Session.getMasterData()!)
    let masterLastDay: any = ''
    let maxHarvestTime = JSON.parse(Session.getLatestHarvestDay()!)

    if (masterData !== null) {
      masterLastDay = String(Object.keys(masterData).pop())
    }

    let maxHarvest = parseInt(maxHarvestTime)
    let maxMaster = parseInt(masterLastDay)
    let maxGraph = parseInt(graphDataLastDay)

    // 全て数値に変換
    const graphMaxDay = parseInt(graphLastDay)
    const status = parseInt(Session.getHarvestStatus()!)
    const harvestStatusDay = Session.getHarvestStatusDay()!
    const updateDate = new Date(harvestStatusDay)
    const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + DateClass.toDoubleDigits(updateDate.getDate())
    const statusChangeDate = parseInt(formingDate)
    let maxDay: any

    if (status === harvestStatus.CHANCEL || status === harvestStatus.HARVESTED || status === harvestStatus.HARVEST_DONE) {
      let day: any
      /*
      * ①収穫適期の最終
      * ②マスターデータの収穫適期
      * ③実測データの最終日
      * どれが一番大きいか
      */
      if (isNaN(maxMaster) && isNaN(maxGraph) && isNaN(maxHarvest)) {
        // 全てのデータがない場合
        this.$emit('show-alert')
        return
      } else if (isNaN(maxMaster) && isNaN(maxGraph)) {
        // マスターデータと実測データがない
        day = maxHarvest
      } else if (isNaN(maxMaster) && isNaN(maxHarvest)) {
        // マスターデータと収穫適期の最終日がない
        day = maxGraph
      } else if (isNaN(maxGraph) && isNaN(maxHarvest)) {
        // 実測データと収穫適期の最終日がない
        day = maxMaster
      } else if (isNaN(maxMaster)) {
        // マスターデータがない
        day = this.judgeMaxDay(maxGraph, maxHarvest)
      } else if (isNaN(maxGraph)) {
        // 実測データがない
        day = this.judgeMaxDay(maxMaster, maxHarvest)
      } else if (isNaN(maxHarvest)) {
        // 収穫適期の最終日がない
        day = this.judgeMaxDay(maxGraph, maxMaster)
      } else {
        // 3つすべて存在する場合
        if (maxMaster >= maxGraph && maxMaster >= maxHarvest) {
          day = maxMaster
        } else if (maxGraph >= maxMaster && maxGraph >= maxHarvest) {
          day = maxGraph
        } else if (maxHarvest >= maxMaster && maxHarvest >= maxGraph) {
          day = maxHarvest
        }
      }
      // ステータス変更日が①②③より大きいか判定
      if (statusChangeDate > day) {
        maxDay = day
      } else {
        if (day === maxGraph && statusChangeDate > maxMaster && statusChangeDate > maxHarvest) {
          maxDay = statusChangeDate
        } else {
          maxDay = graphMaxDay
        }
      }
    } else {
      maxDay = graphMaxDay
    }

    // 最大日を+30日にする
    this.graphMaxDay = DateClass.formingDate(maxDay)
    this.graphMaxDay.setDate(this.graphMaxDay.getDate() + 30)
    this.$store.commit('fieldDetailsState/setMaxDate', this.graphMaxDay)
    for (var i = minDay; i < this.graphMaxDay; i = new Date(i.setDate(i.getDate() + 1))) {
      labels.push(i)
    }

    this.label = labels
    return labels
  }

  /* グラフ描画領域の最大値を判定 */
  public judgeMaxDay (a: number, b: number) : any {
    let maxDay: any

    if (a >= b) {
      maxDay = a
    } else {
      maxDay = b
    }

    return maxDay
  }

  private judgePointRadius (data: any[]) {
    let countNotNull: number = 0
    for (let i in data) {
      if (data[i] !== null) {
        countNotNull++
      }
    }

    // null以外に値が1件ならポイントを表示、それ以外はポイントを表示しない
    if (countNotNull === 1) {
      return 3
    } else {
      return 0
    }
  }

  // 実績と目標のグラフデータ作成
  private createGraphData (key: string, type: string) {
    let plantingData
    const array: any[] = []
    if (type === 'performance') {
      if (key === 'young_head') {
        plantingData = JSON.parse(Session.getYoungData()!)
      } else {
        plantingData = JSON.parse(Session.getGraphData()!)
      }
    } else if (type === 'goal') {
      if (key === 'young_head') {
        plantingData = JSON.parse(Session.getYoungGoalData()!)
      } else {
        plantingData = JSON.parse(Session.getMasterData()!)
      }
    } else if (type === 'test_graph') {
      plantingData = JSON.parse(Session.getTestData()!)
    }

    for (var j in this.label) {
      let day = '' + this.label[j].getFullYear() + DateClass.toDoubleDigits(this.label[j].getMonth() + 1) + DateClass.toDoubleDigits(this.label[j].getDate())
      if (plantingData !== null && plantingData[day] !== undefined) {
        if (key === 'integration_temperature') {
          // 積算温度
          array.push(plantingData[day].integration_temperature)
        } else if (key === 'integrated_precipitation_amount') {
          // 積算降水量
          array.push(plantingData[day].integrated_precipitation_amount)
        } else if (key === 'stem_number') {
          // 茎数
          array.push(plantingData[day].stem_number)
        } else if (key === 'spad') {
          // spad
          array.push(plantingData[day].spad)
        } else if (key === 'growth_height') {
          // 草丈
          array.push(plantingData[day].growth_height)
        } else if (key === 'young_head') {
          // 幼穂長
          array.push(plantingData[day].young_head)
        }
      } else {
        array.push(null)
      }
    }
    return array
  }

  /* 積算温度のデータを作成 */
  // 予測積算温度
  public createPredictionTemperature () {
    let plantingData = this.createGraphData('integration_temperature', 'performance')
    let predictionData = JSON.parse(Session.getPredictionData()!)
    const predictionTemp: any[] = []

    // 実測データの最終日を取得
    let graphData = JSON.parse(Session.getGraphData()!)
    let lastDay: any = Object.keys(graphData).pop()
    // 実績で0以上が1件も無い場合は予測線をすべて表示する
    let isNotNullPlantingData = plantingData.filter(element => element !== null)

    // 目標データがない場合は空を返す
    if (Object.keys(predictionData).length === 0) {
      return []
    }

    if (isNotNullPlantingData.length !== 0) {
      for (var j in this.label) {
        let day = '' + this.label[j].getFullYear() + DateClass.toDoubleDigits(this.label[j].getMonth() + 1) + DateClass.toDoubleDigits(this.label[j].getDate())

        if (predictionData[day] !== undefined && day > lastDay) {
          predictionTemp.push(predictionData[day].integration_temperature)
        } else {
          predictionTemp.push(null)
        }
      }

      // 実測積算温度の最終keyを取得
      const masterDataLastDay: any = Object.keys(predictionData).pop()
      if (lastDay < masterDataLastDay) {
        // null以外で配列を作成
        const array = plantingData.filter((val) => val !== null)
        // 最後の値が何か取得
        const lastDayVal = array.pop()
        // 実績積算温度配列の後ろからlastDayValの配列番号を取得
        const key = plantingData.lastIndexOf(lastDayVal)

        if (predictionTemp[key] === null) {
          predictionTemp[key] = plantingData[key]
        }
      }
    } else {
      for (var i in this.label) {
        let day = '' + this.label[i].getFullYear() + DateClass.toDoubleDigits(this.label[i].getMonth() + 1) + DateClass.toDoubleDigits(this.label[i].getDate())

        if (predictionData[day] !== undefined) {
          predictionTemp.push(predictionData[day].integration_temperature)
        } else {
          predictionTemp.push(null)
        }
      }
    }

    return predictionTemp
  }

  /* 比較データの作成 */
  public createComparisonData () {
    let comparisonData = JSON.parse(Session.getComparisonData()!)
    let comparisonYoungData = JSON.parse(Session.getComparisonYoungData()!)

    const comparisonTemperature: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonStemNumber: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonSpad: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonGrowthHeight: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonIntegratedPrecipitation: any[] = [null, null, null, null, null, null, null, null, null]
    const comparisonYoungHead: any[] = [null, null, null, null, null, null, null, null, null]

    for (var i in comparisonData) {
      comparisonTemperature.push(comparisonData[i].integration_temperature)
      comparisonStemNumber.push(comparisonData[i].stem_number)
      comparisonSpad.push(comparisonData[i].spad)
      comparisonGrowthHeight.push(comparisonData[i].growth_height)
      comparisonIntegratedPrecipitation.push(comparisonData[i].integrated_precipitation_amount)
    }

    for (var j in comparisonYoungData) {
      comparisonYoungHead.push(comparisonYoungData[j].young_head)
    }

    // データの書き換え
    this.chartData.datasets[1].data = comparisonTemperature
    this.chartData.datasets[1].pointRadius = this.judgePointRadius(comparisonTemperature)
    this.chartData.datasets[5].data = comparisonStemNumber
    this.chartData.datasets[5].pointRadius = this.judgePointRadius(comparisonStemNumber)
    this.chartData.datasets[8].data = comparisonSpad
    this.chartData.datasets[8].pointRadius = this.judgePointRadius(comparisonSpad)
    this.chartData.datasets[11].data = comparisonGrowthHeight
    this.chartData.datasets[11].pointRadius = this.judgePointRadius(comparisonGrowthHeight)

    this.areaChartData.datasets[1].data = comparisonIntegratedPrecipitation
    this.areaChartData.datasets[1].pointRadius = this.judgePointRadius(comparisonIntegratedPrecipitation)

    this.youngHeadChartData.datasets[1].data = comparisonYoungHead

    // 凡例書き換え
    let legend1: any = document.getElementById('legend-1')
    let child: any = legend1.getElementsByTagName('li')
    child[1].classList.remove('disabled')
    child[5].classList.remove('disabled')
    child[8].classList.remove('disabled')
    child[11].classList.remove('disabled')

    let legend2: any = document.getElementById('legend-2')
    let child2 = legend2.getElementsByTagName('li')
    child2[1].classList.remove('disabled')

    let legend3: any = document.getElementById('legend-3')
    let child3 = legend3.getElementsByTagName('li')
    child3[1].classList.remove('disabled')

    // 比例ダイアログの表示
    this.$store.commit('graphToggleState/setShowComparison', true)
    this.$store.commit('graphToggleState/setChangeComparisonGraph', false)

    // 再レンダリング
    let graph: any = this.$refs.graph
    let areaGraph: any = this.$refs.areaGraph
    let youngHeadGraph: any = this.$refs.youngHeadGraph

    if (graph !== undefined) {
      graph.updateGraph()
      areaGraph.updateGraph()
      youngHeadGraph.updateGraph()
      this.setCameraIcon()
    }
  }

  /* 比較データ */
  public changeComparisonGraph () {
    // 比較なしの場合は凡例をdisableに戻す
    if (this.$store.state.graphToggleState.hiddenComparisonData) {
      let legend2: any = document.getElementById('legend-2')
      let child2: any = legend2.getElementsByTagName('li')
      child2[1].classList.add('disabled')

      let legend3: any = document.getElementById('legend-3')
      let child3: any = legend3.getElementsByTagName('li')
      child3[1].classList.add('disabled')
    }

    // 再レンダリング
    let graph: any = this.$refs.graph
    let areaGraph: any = this.$refs.areaGraph
    let youngHeadGraph: any = this.$refs.youngHeadGraph

    if (graph !== undefined) {
      graph.updateGraph()
      areaGraph.updateGraph()
      youngHeadGraph.updateGraph()
      this.setCameraIcon()
    }
  }

  /* 収穫適期の最短取得 */
  public getMinHarvestTime () {
    let min = DateClass.formingDate(Session.getEarliestHarvestDay()!)
    return min
  }

  /* 収穫適期の最終取得 */
  public getMaxHarvestTime () {
    let max = DateClass.formingDate(Session.getLatestHarvestDay()!)
    return max
  }

  /* 目標収穫適期の最早取得 */
  public getGoalEarliestHarvestDay () {
    let earliest = DateClass.formingDate(Session.getGoalEarliestHarvestDay()!)
    return earliest
  }

  /* 目標収穫適期の最遅取得 */
  public getGoalLatestHarvestDay () {
    let latest = DateClass.formingDate(Session.getGoalLatestHarvestDay()!)
    return latest
  }

  /* 検証収穫適期の最早取得 */
  public getTestEarliestHarvestDay () {
    let earliest = DateClass.formingDate(Session.getTestEarliestHarvestDay()!)
    return earliest
  }

  /* 検証収穫適期の最遅取得 */
  public getTestLatestHarvestDay () {
    let latest = DateClass.formingDate(Session.getTestLatestHarvestDay()!)
    return latest
  }

  /* ステージバーの日付 */
  public createStageBar (growthStageList: any[]) {
    const growthDateList: any[] = []

    // ステージデータがない場合はステージバーを作らない
    if (growthStageList.length === 1 && growthStageList[0].id === 0) {
      return
    }

    for (var i in growthStageList) {
      let plantingDay = DateClass.formingDate(Session.getPlantingDay()!)
      plantingDay.setDate(plantingDay.getDate() + growthStageList[i].days)

      growthDateList.push(plantingDay)
    }

    for (var j = 0; j < growthDateList.length; j++) {
      let stageLine = {}
      let stageLabel = {}
      let dateLabel = {}

      /* 線のみ描画 */
      if (j !== 4) {
        stageLine = {
          drawTime: 'beforeDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'barLine/' + growthStageList[j].growth_step + growthStageList[j].id,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: '#6A9B01',
          borderWidth: 2
        }
        this.chartOptions.annotation.annotations.push(stageLine)
      } else {
        stageLine = {
          drawTime: 'beforeDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'barLine/' + growthStageList[j].growth_step + growthStageList[j].id,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: '#6A9B01',
          borderWidth: 2
        }
        this.chartOptions.annotation.annotations.push(stageLine)
      }

      /* ラベルのみ描画 */
      if (j % 2 === 0) {
        stageLabel = {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'bar/' + growthStageList[j].growth_step + growthStageList[j].id,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: 'rgba(0,0,0,0)',
          borderWidth: 2,
          label: {
            backgroundColor: this.changeStageBg(growthStageList[j].growth_stage_histories),
            fontColor: '#fff',
            content: this.createContent(growthStageList[j].name),
            fontStyle: 'bold',
            enabled: true,
            xPadding: 10,
            yPadding: 10,
            yAdjust: 10,
            position: 'top'
          },
          onMouseover: function (el: any) {
            CommonClass.setGrowthData(this, el)
          },
          onMouseleave: this.closeGraphDialog,
          onClick: this.changeStageDate
        }
        dateLabel = {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'label/' + growthStageList[j].growth_step + growthStageList[j].id,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: 'rgba(0,0,0,0)',
          borderWidth: 2,
          label: {
            backgroundColor: this.changeStageBg(growthStageList[j].growth_stage_histories),
            fontColor: '#fff',
            content: this.createLabel(growthStageList[j]),
            fontStyle: 'bold',
            enabled: true,
            xPadding: 19,
            yAdjust: 30,
            position: 'top'
          },
          onMouseover: function (el: any) {
            CommonClass.setGrowthData(this, el)
          },
          onMouseleave: this.closeGraphDialog
        }
      } else {
        stageLabel = {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'bar/' + growthStageList[j].growth_step + growthStageList[j].id,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: 'rgba(0,0,0,0)',
          borderWidth: 2,
          label: {
            backgroundColor: this.changeStageBg(growthStageList[j].growth_stage_histories),
            fontColor: '#fff',
            content: this.createContent(growthStageList[j].name),
            fontStyle: 'bold',
            enabled: true,
            xPadding: 10,
            yPadding: 10,
            yAdjust: 60,
            position: 'top'
          },
          onMouseover: function (el: any) {
            CommonClass.setGrowthData(this, el)
          },
          onMouseleave: this.closeGraphDialog,
          onClick: this.changeStageDate
        }
        dateLabel = {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'label/' + growthStageList[j].growth_step + growthStageList[j].id,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: 'rgba(0,0,0,0)',
          borderWidth: 2,
          label: {
            backgroundColor: this.changeStageBg(growthStageList[j].growth_stage_histories),
            fontColor: '#fff',
            content: this.createLabel(growthStageList[j]),
            fontStyle: 'bold',
            enabled: true,
            xPadding: 19,
            yAdjust: 80,
            position: 'top'
          },
          onMouseover: function (el: any) {
            CommonClass.setGrowthData(this, el)
          },
          onMouseleave: this.closeGraphDialog
        }
      }

      this.chartOptions.annotation.annotations.push(stageLabel)
      this.chartOptions.annotation.annotations.push(dateLabel)
    }

    // 検証収穫適期範囲
    let testHarvestTime = {
      drawTime: 'beforeDatasetsDraw',
      type: 'box',
      xScaleID: 'x-axis-0',
      yScaleID: 'yAxis_2',
      xMin: this.getTestEarliestHarvestDay(), // 変数で取得
      xMax: this.getTestLatestHarvestDay(), // 変数で取得
      yMin: 0,
      yMax: 100,
      backgroundColor: this.testHarvestTimeColor,
      borderColor: this.testHarvestTimeColor
    }

    // 収穫適期範囲
    let harvestTime = {
      drawTime: 'beforeDatasetsDraw',
      type: 'box',
      xScaleID: 'x-axis-0',
      yScaleID: 'yAxis_2',
      xMin: this.getMinHarvestTime(), // 変数で取得
      xMax: this.getMaxHarvestTime(), // 変数で取得
      yMin: 0,
      yMax: 100,
      backgroundColor: this.harvestTimeColor,
      borderColor: this.harvestTimeColor
    }

    // 目標収穫適期範囲
    let goalHarvestTime = {
      drawTime: 'beforeDatasetsDraw',
      type: 'box',
      xScaleID: 'x-axis-0',
      yScaleID: 'yAxis_2',
      xMin: this.getGoalEarliestHarvestDay(), // 変数で取得
      xMax: this.getGoalLatestHarvestDay(), // 変数で取得
      yMin: 0,
      yMax: 100,
      backgroundColor: this.goalHarvestTimeColor,
      borderColor: this.goalHarvestTimeColor
    }

    this.chartOptions.annotation.annotations.push(testHarvestTime)
    this.chartOptions.annotation.annotations.push(harvestTime)
    this.chartOptions.annotation.annotations.push(goalHarvestTime)
  }

  private changeStageBg (val: any[]) {
    if (val === undefined || val.length === 0) {
      return '#62766A'
    } else {
      return '#47cc49'
    }
  }

  // ステージバーの更新
  public updateStageBar (growthStageList: any[]) {
    const growthDateList: any[] = []

    for (var i in growthStageList) {
      let plantingDay = DateClass.formingDate(Session.getPlantingDay()!)
      plantingDay.setDate(plantingDay.getDate() + growthStageList[i].days)

      growthDateList.push(plantingDay)
    }

    for (var j = 0; j < growthDateList.length; j++) {
      let stageLine = {}
      let stageLabel = {}
      let dateLabel = {}

      /* 線のみ描画 */
      if (j % 2 === 0) {
        stageLine = {
          drawTime: 'beforeDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'barLine/' + growthStageList[j].growth_step + growthStageList[j].id,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: '#6A9B01',
          borderWidth: 2
        }
      } else {
        stageLine = {
          drawTime: 'beforeDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'barLine/' + growthStageList[j].growth_step + growthStageList[j].id,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: '#6A9B01',
          borderWidth: 2
        }
      }

      /* ラベルのみ描画 */
      if (j % 2 === 0) {
        stageLabel = {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'bar/' + growthStageList[j].growth_step + growthStageList[j].id,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: 'rgba(0,0,0,0)',
          borderWidth: 2,
          label: {
            backgroundColor: this.changeStageBg(growthStageList[j].growth_stage_histories),
            fontColor: '#fff',
            content: this.createContent(growthStageList[j].name),
            fontStyle: 'bold',
            enabled: true,
            xPadding: 10,
            yPadding: 10,
            yAdjust: 10,
            position: 'top'
          },
          onMouseover: function (el: any) {
            CommonClass.setGrowthData(this, el)
          },
          onMouseleave: this.closeGraphDialog,
          onClick: this.changeStageDate
        }
        dateLabel = {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'label/' + growthStageList[j].growth_step + growthStageList[j].id,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: 'rgba(0,0,0,0)',
          borderWidth: 2,
          label: {
            backgroundColor: this.changeStageBg(growthStageList[j].growth_stage_histories),
            fontColor: '#fff',
            content: this.createLabel(growthStageList[j]),
            fontStyle: 'bold',
            enabled: true,
            xPadding: 19,
            yAdjust: 30,
            position: 'top'
          },
          onMouseover: function (el: any) {
            CommonClass.setGrowthData(this, el)
          },
          onMouseleave: this.closeGraphDialog
        }
      } else {
        stageLabel = {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'bar/' + growthStageList[j].growth_step + growthStageList[j].id,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: 'rgba(0,0,0,0)',
          borderWidth: 2,
          label: {
            backgroundColor: this.changeStageBg(growthStageList[j].growth_stage_histories),
            fontColor: '#fff',
            content: this.createContent(growthStageList[j].name),
            fontStyle: 'bold',
            enabled: true,
            xPadding: 10,
            yPadding: 10,
            yAdjust: 60,
            position: 'top'
          },
          onMouseover: function (el: any) {
            CommonClass.setGrowthData(this, el)
          },
          onMouseleave: this.closeGraphDialog,
          onClick: this.changeStageDate
        }
        dateLabel = {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          id: 'label/' + growthStageList[j].growth_step + growthStageList[j].id,
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: 'rgba(0,0,0,0)',
          borderWidth: 2,
          label: {
            backgroundColor: this.changeStageBg(growthStageList[j].growth_stage_histories),
            fontColor: '#fff',
            content: this.createLabel(growthStageList[j]),
            fontStyle: 'bold',
            enabled: true,
            xPadding: 19,
            yAdjust: 80,
            position: 'top'
          },
          onMouseover: function (el: any) {
            CommonClass.setGrowthData(this, el)
          },
          onMouseleave: this.closeGraphDialog
        }
      }

      this.chartOptions.annotation.annotations[j] = stageLine
      this.chartOptions.annotation.annotations[j + 5] = stageLabel
      this.chartOptions.annotation.annotations[j + 10] = dateLabel

      let testHarvestTime = {
        drawTime: 'beforeDatasetsDraw',
        type: 'box',
        xScaleID: 'x-axis-0',
        yScaleID: 'yAxis_2',
        xMin: this.getTestEarliestHarvestDay(), // 変数で取得
        xMax: this.getTestLatestHarvestDay(), // 変数で取得
        yMin: 0,
        yMax: 100,
        backgroundColor: this.testHarvestTimeColor,
        borderColor: this.testHarvestTimeColor
      }

      let harvestTime = {
        drawTime: 'beforeDatasetsDraw',
        type: 'box',
        xScaleID: 'x-axis-0',
        yScaleID: 'yAxis_2',
        xMin: this.getMinHarvestTime(), // 変数で取得
        xMax: this.getMaxHarvestTime(), // 変数で取得
        yMin: 0,
        yMax: 100,
        backgroundColor: this.harvestTimeColor,
        borderColor: this.harvestTimeColor
      }

      let goalHarvestTime = {
        drawTime: 'beforeDatasetsDraw',
        type: 'box',
        xScaleID: 'x-axis-0',
        yScaleID: 'yAxis_2',
        xMin: this.getGoalEarliestHarvestDay(), // 変数で取得
        xMax: this.getGoalLatestHarvestDay(), // 変数で取得
        yMin: 0,
        yMax: 100,
        backgroundColor: this.goalHarvestTimeColor,
        borderColor: this.goalHarvestTimeColor
      }

      this.chartOptions.annotation.annotations[15] = testHarvestTime
      this.chartOptions.annotation.annotations[16] = harvestTime
      this.chartOptions.annotation.annotations[17] = goalHarvestTime
    }

    // ステージの日付変更した際に再レンダリングをする処理
    let graph: any = this.$refs.graph
    if (graph !== undefined) {
      graph.updateGraph()
      this.setCameraIcon()
    }
  }

  /* ステージバーの表示中身作成 */
  private createContent (name: any) {
    if (name === '播種期') {
      return ' 播 種 期 '
    }
    return name
  }

  private createLabel (data: any) {
    let content: string
    let plantingDate = DateClass.formingDate(Session.getPlantingDay()!)
    let newDate = new Date(plantingDate.getTime() + (data.days * 24 * 60 * 60 * 1000))

    content = DateClass.toDoubleDigits(newDate.getMonth() + 1) + '/' + DateClass.toDoubleDigits(newDate.getDate())
    return content
  }

  /* ステージバーをクリックしたときの処理 */
  public changeStageDate (event: any) {
    this.showDetailsDialog = false
    let growthData = Vue.prototype.$globalGrowthData
    let plantingDate = DateClass.formingDate(Session.getPlantingDay()!)
    let newDate = new Date(plantingDate.getTime() + (growthData.days * 24 * 60 * 60 * 1000))
    let date = parseInt('' + newDate.getFullYear() + DateClass.toDoubleDigits(newDate.getMonth() + 1) + DateClass.toDoubleDigits(newDate.getDate()))
    let today = parseInt('' + new Date().getFullYear() + DateClass.toDoubleDigits(new Date().getMonth() + 1) + DateClass.toDoubleDigits(new Date().getDate()))

    // 播種日と今日より先は変更不可
    if (growthData.name !== '播種期' && date <= today) {
      this.$store.commit('stageUpdateState/setChangeId', parseInt(growthData.id))
      this.showStageUpdateModal = true
    }
  }

  public closeStageUpdateModal () {
    this.showStageUpdateModal = false
  }

  /* ステージバーの更新処理 */
  private reacquireStage () {
    this.$emit('reacquire-stage-data')
  }

  /* スライドバー移動処理 */
  public changeDate (e: any) {
    let date = this.label[this.slide]
    let keyDate = parseInt('' + date.getFullYear() + DateClass.toDoubleDigits(date.getMonth() + 1) + DateClass.toDoubleDigits(date.getDate()))

    /* state管理 */
    this.$store.commit('dateChoiceState/setChangeDate', keyDate)
  }

  public overWriteDate (e: any) {
    let date = e.subject.config.value._d
    let keyDate = parseInt('' + date.getFullYear() + DateClass.toDoubleDigits(date.getMonth() + 1) + DateClass.toDoubleDigits(date.getDate()))
    /* state管理 */
    this.$store.commit('dateChoiceState/setChangeDate', keyDate)
  }

  /* グラフのダイアログを表示 */
  public showGraphDialog () {
    if (!this.showDetailsDialog) {
      this.growthData = Vue.prototype.$globalGrowthData
      this.stageDate = Vue.prototype.$globalStageDate
      this.$store.commit('setFlagState/setGraphDialogFlag', true)
      let growthStageList = JSON.parse(Session.getGrowthStage()!)

      // ポジション
      this.dialogLeft = (Vue.prototype.$globalElX - 50) + 'px'

      for (let i in growthStageList) {
        if (growthStageList[i].growth_step === this.growthData.growth_step) {
          let num = parseInt(i) % 2
          if (num === 0) {
            this.dialogTop = '65px'
          } else {
            this.dialogTop = '115px'
          }
          break
        }
      }

      this.toggleDialog()
    } else {
      this.toggleDialog()
    }
  }

  public toggleDialog () {
    if (this.showDetailsDialog) {
      this.showDetailsDialog = false
    } else {
      this.showDetailsDialog = true
    }
  }

  public closeGraphDialog ($event: any) {
    $event.preventDefault()
    this.showDetailsDialog = false
  }

  /* グラフ表示切り替え */
  public displayGraph (data: any) {
    this.checkboxData = data
    let legend1: any = document.getElementById('legend-1')
    let legend2: any = document.getElementById('legend-2')
    let legend3: any = document.getElementById('legend-3')
    let child: any = legend1.getElementsByTagName('li')
    let areaChild: any = legend2.getElementsByTagName('li')
    let youngHeadChild: any = legend3.getElementsByTagName('li')

    let testData = JSON.parse(Session.getTestData()!)

    for (var i in data) {
      if (data[i].label === '積算温度') {
        if (!data[i].checked) {
          this.chartData.datasets[0].hidden = true
          this.chartData.datasets[1].hidden = true
          this.chartData.datasets[2].hidden = true
          this.chartData.datasets[3].hidden = true
          this.chartData.datasets[4].hidden = true

          this.chartOptions.annotation.annotations[15].backgroundColor = 'rgba(0, 0, 0, 0)'
          this.chartOptions.annotation.annotations[15].borderColor = 'rgba(0, 0, 0, 0)'

          this.chartOptions.annotation.annotations[16].backgroundColor = 'rgba(0, 0, 0, 0)'
          this.chartOptions.annotation.annotations[16].borderColor = 'rgba(0, 0, 0, 0)'

          this.chartOptions.annotation.annotations[17].backgroundColor = 'rgba(0, 0, 0, 0)'
          this.chartOptions.annotation.annotations[17].borderColor = 'rgba(0, 0, 0, 0)'
          // 凡例書き換え
          child[0].classList.add('hidden')
          child[1].classList.add('hidden')
          child[2].classList.add('hidden')
          child[3].classList.add('hidden')
          child[4].classList.add('hidden')
        } else {
          this.chartData.datasets[0].hidden = false
          this.chartData.datasets[1].hidden = false
          this.chartData.datasets[2].hidden = false
          this.chartData.datasets[3].hidden = false
          this.chartData.datasets[4].hidden = false

          testData === null ? this.chartOptions.annotation.annotations[15].backgroundColor = 'rgba(0, 0, 0, 0)' : this.chartOptions.annotation.annotations[15].backgroundColor = this.testHarvestTimeColor
          testData === null ? this.chartOptions.annotation.annotations[15].borderColor = 'rgba(0, 0, 0, 0)' : this.chartOptions.annotation.annotations[15].borderColor = this.testHarvestTimeColor

          this.chartOptions.annotation.annotations[16].backgroundColor = this.harvestTimeColor
          this.chartOptions.annotation.annotations[16].borderColor = this.harvestTimeColor

          this.chartOptions.annotation.annotations[17].backgroundColor = this.goalHarvestTimeColor
          this.chartOptions.annotation.annotations[17].borderColor = this.goalHarvestTimeColor

          // 凡例書き換え
          child[0].classList.remove('hidden')
          child[1].classList.remove('hidden')
          child[2].classList.remove('hidden')
          child[3].classList.remove('hidden')
          child[4].classList.remove('hidden')
        }
      }

      if (data[i].label === '草丈') {
        if (!data[i].checked) {
          this.chartData.datasets[11].hidden = true
          this.chartData.datasets[12].hidden = true
          this.chartData.datasets[13].hidden = true
          // 凡例書き換え
          child[11].classList.add('hidden')
          child[12].classList.add('hidden')
          child[13].classList.add('hidden')
        } else {
          this.chartData.datasets[11].hidden = false
          this.chartData.datasets[12].hidden = false
          this.chartData.datasets[13].hidden = false
          // 凡例書き換え
          child[11].classList.remove('hidden')
          child[12].classList.remove('hidden')
          child[13].classList.remove('hidden')
        }
      }

      if (data[i].label === '茎数') {
        if (!data[i].checked) {
          this.chartData.datasets[5].hidden = true
          this.chartData.datasets[6].hidden = true
          this.chartData.datasets[7].hidden = true
          // 凡例書き換え
          child[5].classList.add('hidden')
          child[6].classList.add('hidden')
          child[7].classList.add('hidden')
        } else {
          this.chartData.datasets[5].hidden = false
          this.chartData.datasets[6].hidden = false
          this.chartData.datasets[7].hidden = false
          // 凡例書き換え
          child[5].classList.remove('hidden')
          child[6].classList.remove('hidden')
          child[7].classList.remove('hidden')
        }
      }

      if (data[i].label === '積算降水量') {
        if (!data[i].checked) {
          this.showAreaChart = false
        } else {
          this.showAreaChart = true
          this.areaChartData.datasets[0].hidden = false
          this.areaChartData.datasets[1].hidden = false
          this.areaChartData.datasets[2].hidden = false
          // 凡例書き換え
          areaChild[0].classList.remove('hidden')
          areaChild[1].classList.remove('hidden')
          areaChild[2].classList.remove('hidden')
        }
      }

      if (data[i].label === '幼穂長') {
        if (!data[i].checked) {
          this.showYoungHeadChart = false
        } else {
          this.showYoungHeadChart = true
          this.youngHeadChartData.datasets[0].hidden = false
          this.youngHeadChartData.datasets[1].hidden = false
          this.youngHeadChartData.datasets[2].hidden = false
          // 凡例書き換え
          youngHeadChild[0].classList.remove('hidden')
          youngHeadChild[1].classList.remove('hidden')
          youngHeadChild[2].classList.remove('hidden')
        }
      }

      if (data[i].label === 'SPAD') {
        if (!data[i].checked) {
          this.chartData.datasets[8].hidden = true
          this.chartData.datasets[9].hidden = true
          this.chartData.datasets[10].hidden = true
          // 凡例書き換え
          child[8].classList.add('hidden')
          child[9].classList.add('hidden')
          child[10].classList.add('hidden')
        } else {
          this.chartData.datasets[8].hidden = false
          this.chartData.datasets[9].hidden = false
          this.chartData.datasets[10].hidden = false
          // 凡例書き換え
          child[8].classList.remove('hidden')
          child[9].classList.remove('hidden')
          child[10].classList.remove('hidden')
        }
      }
    }

    // 比較系
    if (!this.$store.state.graphToggleState.hiddenComparisonData) {
      child[1].classList.remove('disabled')
      child[6].classList.remove('disabled')
      child[9].classList.remove('disabled')
      child[12].classList.remove('disabled')
      areaChild[1].classList.remove('disabled')
      youngHeadChild[1].classList.remove('disabled')
    } else {
      child[1].classList.add('disabled')
      child[6].classList.add('disabled')
      child[9].classList.add('disabled')
      child[12].classList.add('disabled')
      areaChild[1].classList.add('disabled')
      youngHeadChild[1].classList.add('disabled')
      // 比較非表示の時取り消し線は表示しない
      child[1].classList.remove('hidden')
      child[6].classList.remove('hidden')
      child[9].classList.remove('hidden')
      child[12].classList.remove('hidden')
      areaChild[1].classList.remove('hidden')
      youngHeadChild[1].classList.remove('hidden')
    }

    // 再レンダリング
    let graph: any = this.$refs.graph
    let areaGraph: any = this.$refs.areaGraph
    let youngHeadGraph: any = this.$refs.youngHeadGraph

    if (graph !== undefined) {
      graph.updateGraph()
      areaGraph.updateGraph()
      youngHeadGraph.updateGraph()
      this.setCameraIcon()
    }
  }

  public displayLegend () {
    let myLegend: any = document.getElementById('legend-1')
    let legendItems: any = myLegend.getElementsByTagName('li')
    for (var i = 0; i < legendItems.length; i += 1) {
      legendItems[i].addEventListener('click', this.legendClickEvents, false)
    }
  }

  public displayAreaLegend () {
    let myLegend2: any = document.getElementById('legend-2')
    let legendItems2: any = myLegend2.getElementsByTagName('li')

    for (var j = 0; j < legendItems2.length; j += 1) {
      legendItems2[j].addEventListener('click', this.areaLegendClickEvents, false)
    }
  }

  public displayYoungHeadLegend () {
    let myLegend3: any = document.getElementById('legend-3')
    let legendItems3: any = myLegend3.getElementsByTagName('li')

    for (var j = 0; j < legendItems3.length; j += 1) {
      legendItems3[j].addEventListener('click', this.youngHeadLegendClickEvents, false)
    }
  }

  public legendClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    let parent = target.parentElement
    let child = parent.getElementsByTagName('li')
    var index = Array.prototype.slice.call(child).indexOf(target)

    // 比較系はデータがない場合変更できない
    if (this.chartData.datasets[index].label.startsWith('比較')) {
      if (this.$store.state.graphToggleState.hiddenComparisonData) {
        return
      }
    }

    if (this.chartData.datasets[index].hidden === null || this.chartData.datasets[index].hidden === false) {
      this.chartData.datasets[index].hidden = true
      target.classList.add('hidden')
    } else {
      this.chartData.datasets[index].hidden = false
      target.classList.remove('hidden')
    }

    if (this.chartData.datasets[index].label === '検証積算温度(℃)') {
      if (this.chartData.datasets[index].hidden) {
        this.chartOptions.annotation.annotations[15].backgroundColor = this.transparentColor
        this.chartOptions.annotation.annotations[15].borderColor = this.transparentColor
      } else {
        this.chartOptions.annotation.annotations[15].backgroundColor = this.testHarvestTimeColor
        this.chartOptions.annotation.annotations[15].borderColor = this.testHarvestTimeColor
      }
    } else if (this.chartData.datasets[index].label === '実績積算温度(℃)') {
      if (this.chartData.datasets[index].hidden) {
        this.chartOptions.annotation.annotations[16].backgroundColor = this.transparentColor
        this.chartOptions.annotation.annotations[16].borderColor = this.transparentColor
      } else {
        this.chartOptions.annotation.annotations[16].backgroundColor = this.harvestTimeColor
        this.chartOptions.annotation.annotations[16].borderColor = this.harvestTimeColor
      }
    } else if (this.chartData.datasets[index].label === '目標積算温度(℃)') {
      if (this.chartData.datasets[index].hidden) {
        this.chartOptions.annotation.annotations[17].backgroundColor = this.transparentColor
        this.chartOptions.annotation.annotations[17].borderColor = this.transparentColor
      } else {
        this.chartOptions.annotation.annotations[17].backgroundColor = this.goalHarvestTimeColor
        this.chartOptions.annotation.annotations[17].borderColor = this.goalHarvestTimeColor
      }
    }

    let graph: any = this.$refs.graph
    if (graph !== undefined) {
      graph.updateGraph()
    }
  }

  public areaLegendClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    let parent = target.parentElement
    let child = parent.getElementsByTagName('li')
    var index = Array.prototype.slice.call(child).indexOf(target)

    // 比較系はデータがない場合変更できない
    if (this.areaChartData.datasets[index].label.startsWith('比較')) {
      if (this.$store.state.graphToggleState.hiddenComparisonData) {
        return
      }
    }

    if (this.areaChartData.datasets[index].hidden === null || this.areaChartData.datasets[index].hidden === false) {
      this.areaChartData.datasets[index].hidden = true
      target.classList.add('hidden')
    } else {
      this.areaChartData.datasets[index].hidden = false
      target.classList.remove('hidden')
    }

    let areaGraph: any = this.$refs.areaGraph
    if (areaGraph !== undefined) {
      areaGraph.updateGraph()
    }
  }

  public youngHeadLegendClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    let parent = target.parentElement
    let child = parent.getElementsByTagName('li')
    var index = Array.prototype.slice.call(child).indexOf(target)

    // 比較系はデータがない場合変更できない
    if (this.youngHeadChartData.datasets[index].label.startsWith('比較')) {
      if (this.$store.state.graphToggleState.hiddenComparisonData) {
        return
      }
    }

    if (this.youngHeadChartData.datasets[index].hidden === null || this.youngHeadChartData.datasets[index].hidden === false) {
      this.youngHeadChartData.datasets[index].hidden = true
      target.classList.add('hidden')
    } else {
      this.youngHeadChartData.datasets[index].hidden = false
      target.classList.remove('hidden')
    }

    let youngHeadGraph: any = this.$refs.youngHeadGraph
    if (youngHeadGraph !== undefined) {
      youngHeadGraph.updateGraph()
    }
  }

  public showErrorToast (msg: string) {
    this.$emit('show-error-alert', msg)
  }
}
